<template>
    <nav class="navbar navbar-static-top hhsoft-navbar" role="navigation" style="margin-bottom: 0">
        <el-row type="flex">
            <el-col :span="10">
                <el-button type="primary" icon="el-icon-s-fold" size="small" class="expandbutton" @click="handleClickOutside" ></el-button>
            </el-col>
            <el-col :span="20">
                <div class="markhead">
                    <div>
                        
                        <span style="margin-right:20px">欢迎使用河南省计划生育扶助保障信息系统</span>
                    </div>
                    <div class="notice" @click="morenoticelist">
                        <i class="el-icon-message-solid"></i>
                        <span style="margin-right:20px">公告</span>
                    </div>
                    <div>
                        <el-link :underline="false" icon="el-icon-s-unfold" v-on:click.prevent.stop="logOut()">退出登录</el-link>
                    </div>
                  
                    
                </div>
            </el-col>
        </el-row>
    </nav>
</template>

<script>

import router from '@/router.js'
// import Cookies from 'js-cookie'
// import $ from 'jquery'
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
        }),
    },
    created(){
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch('app/toggleSideBar', { withoutAnimation: false })
        },
        logOut(){
            this.$store.dispatch('admin/removeAdminID')
            this.$store.dispatch('admin/removeToken')
            this.$store.dispatch('tab/clearTab')
            router.replace('login')
        },
         async morenoticelist(){
            //  this.$router.push({
            //     path:'/welcomenoticelist',
            // })
            // // router.push({ path: '/welcomenoticelist' });
            // this.$store.dispatch("tab/setActiveName", '/welcomenoticelist');
            // let obj={ taburl: '/welcomenoticelist', tabicon: 'el-icon-message-solid', tabtitle: '公告查询' }
            // this.$store.dispatch("tab/addTab", obj);
                if(this.$router.history.current.path!='/welcomenoticelist'){
                        this.$router.push({
                            path:'/welcomenoticelist',
                        })
                        // router.push({ path: '/welcomenoticelist' });
                        this.$store.dispatch("tab/setActiveName", '/welcomenoticelist');
                        let obj={ taburl: '/welcomenoticelist', tabicon: 'el-icon-message-solid', tabtitle: '公告查询' }
                        this.$store.dispatch("tab/addTab", obj);
                }
        },
    }
}
</script>

<style scoped>
    .expandbutton{
        margin: 10px 5px 5px 20px;
        width: 30px;
        height: 30px;
        padding: 2px 2px;
        font-size: 16px;
    }
    .markhead{
        text-align: right;
        margin-right: 10px;
        position: relative;
        top:50%;
        transform:translateY(-50%);
        display: flex;
        justify-content: flex-end;
    }
    .el-link{
        /* vertical-align: ; */
        /* vertical-align: inherit; */
        vertical-align: initial;
        font-size: 17px;
    }
    .el-icon-message-solid{
         font-size: 15px;
         margin-right: 5px;
    }
    .notice{
        cursor: pointer;
    }
    
</style>